import { Check, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useWebsiteContent } from "@/hooks/useWebsiteContent";

const Packages = () => {
  const { content } = useWebsiteContent();

  return (
    <section id="packages" className="py-20 md:py-28 bg-card">
      <div className="max-w-[980px] mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center max-w-[680px] mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-[56px] font-semibold text-foreground tracking-[-0.03em] leading-tight mb-4">
            {content.packages_title}
          </h2>
          <p className="text-xl text-muted-foreground font-normal">
            {content.packages_subtitle}
          </p>
        </div>

        {/* Packages */}
        <div className="space-y-16">
          {content.packages.map((category, catIndex) => (
            <div key={catIndex}>
              <h3 className="text-2xl font-semibold text-foreground mb-8 text-center tracking-tight">
                {category.category}
              </h3>
              <div className="grid md:grid-cols-2 gap-5 max-w-3xl mx-auto">
                {category.items.map((pkg, pkgIndex) => (
                  <div
                    key={pkgIndex}
                    className={`relative bg-background rounded-2xl p-8 transition-all duration-300 hover:shadow-md h-full flex flex-col ${
                      pkg.featured ? "ring-2 ring-primary" : ""
                    }`}
                  >
                    {pkg.featured && (
                      <div className="absolute -top-3 left-1/2 -translate-x-1/2 flex items-center gap-1 bg-primary text-primary-foreground px-3 py-0.5 rounded-full text-[11px] font-semibold">
                        <Star className="w-3 h-3" />
                        Most Popular
                      </div>
                    )}

                    <h4 className="text-lg font-semibold text-foreground mb-1 tracking-tight">
                      {pkg.name}
                    </h4>
                    <p className="text-sm text-muted-foreground mb-6">{pkg.duration}</p>

                    <ul className="space-y-3 mb-8 flex-1">
                      {pkg.features.map((feature, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-foreground/70">
                          <Check className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <Button
                      variant={pkg.featured ? "default" : "outline"}
                      className="w-full rounded-full"
                      asChild
                    >
                      <a href="#contact">Get Started</a>
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Add-ons */}
        <div className="mt-20 max-w-xl mx-auto">
          <h3 className="text-2xl font-semibold text-foreground mb-8 text-center tracking-tight">
            Add-On Services
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {content.packages_addons.map((addOn, index) => (
              <div key={index} className="p-4 bg-background rounded-xl flex items-center justify-between gap-3">
                <span className="text-sm text-foreground/70">{addOn.name}</span>
                <span className="text-sm font-semibold text-foreground">{addOn.price}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Packages;
